<!-- Boundary Editor Component -->
<div class="position-relative">

  <!-- Mobile Read-Only Message -->
  <div *ngIf="isMobile" class="alert alert-info mb-2 py-2 small">
    <i class="bi bi-info-circle me-1"></i>Boundary editing is available on desktop
  </div>

  <!-- Vertex Count Warning -->
  <div *ngIf="vertexWarning" class="alert alert-warning mb-2 py-2 small">
    <i class="bi bi-exclamation-triangle me-1"></i>{{ vertexWarning }}
  </div>

  <!-- Upload Error -->
  <div *ngIf="uploadError" class="alert alert-danger mb-2 py-2 small">
    <i class="bi bi-exclamation-triangle me-1"></i>{{ uploadError }}
    <button type="button" class="btn-close btn-close-sm float-end" (click)="uploadError = null" aria-label="Close"></button>
  </div>

  <!-- Google Map -->
  <div class="map-wrapper"
       [class.dragging]="isDragging"
       (dragover)="!isMobile ? onDragOver($event) : null"
       (dragleave)="!isMobile ? onDragLeave($event) : null"
       (drop)="!isMobile ? onDrop($event) : null">

    <google-map
      height="400px"
      width="100%"
      [zoom]="zoom"
      [center]="center"
      [options]="mapOptions"
      (mapInitialized)="onMapReady($event)">
    </google-map>

    <!-- Drop Overlay -->
    <div *ngIf="isDragging && !isMobile" class="drop-overlay">
      <div class="drop-overlay-content">
        <i class="bi bi-cloud-upload fs-1"></i>
        <p class="mb-0 mt-2">Drop file to import boundary</p>
      </div>
    </div>

    <!-- Processing Overlay -->
    <div *ngIf="isProcessing" class="processing-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Processing...</span>
      </div>
      <p class="mt-2 mb-0">Processing file...</p>
    </div>
  </div>

  <!-- Desktop Controls -->
  <div *ngIf="!isMobile" class="d-flex flex-wrap gap-2 mt-2 align-items-center">
    <!-- Clear Boundary Button -->
    <button type="button"
            class="btn btn-sm btn-outline-danger"
            [disabled]="!hasPolygon"
            (click)="clearBoundary()"
            title="Clear boundary polygon">
      <i class="bi bi-trash me-1"></i>Clear Boundary
    </button>

    <!-- File Import -->
    <label class="btn btn-sm btn-outline-primary mb-0">
      <i class="bi bi-upload me-1"></i>Import File
      <input type="file"
             class="d-none"
             accept=".kml,.geojson,.json"
             (change)="onFileSelected($event)">
    </label>

    <!-- Flight Path Import Dropdown -->
    <div *ngIf="fieldId && flightPaths.length > 0" class="d-flex gap-1 align-items-center">
      <select class="form-select form-select-sm flight-path-select"
              [(ngModel)]="selectedFlightPathId"
              (ngModelChange)="onFlightPathSelected()">
        <option [ngValue]="null" disabled>Import from flight...</option>
        <option *ngFor="let fp of flightPaths" [ngValue]="fp.id">
          {{ fp.name }} ({{ fp.date }})
        </option>
      </select>
    </div>

    <!-- Loading indicator for flight paths -->
    <span *ngIf="loadingFlightPaths" class="text-muted small">
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
      Loading flights...
    </span>
  </div>

  <!-- Drag/Drop Hint (desktop only, no polygon) -->
  <p *ngIf="!isMobile && !hasPolygon" class="text-muted small mt-1 mb-0">
    Draw a polygon on the map, import a boundary file (KML or GeoJSON), or drag and drop a file onto the map.
  </p>

  <!-- Boundary Coordinates Detail -->
  @if (hasPolygon && polygonCoordinates.length > 0) {
    <div class="mt-2">
      <button type="button"
              class="btn btn-sm btn-link text-muted p-0 text-decoration-none"
              (click)="showCoordinates = !showCoordinates">
        <i class="bi me-1" [class.bi-chevron-right]="!showCoordinates" [class.bi-chevron-down]="showCoordinates"></i>
        {{ polygonCoordinates.length }} vertices
      </button>
      @if (showCoordinates) {
        <div class="mt-1">
          <div class="table-responsive coords-scroll overflow-y-auto">
            <table class="table table-sm table-borderless mb-0 small coords-table">
              <thead>
                <tr class="text-muted">
                  <th>#</th>
                  <th>Latitude</th>
                  <th>Longitude</th>
                </tr>
              </thead>
              <tbody>
                @for (coord of polygonCoordinates; track $index) {
                  <tr>
                    <td class="text-muted">{{ $index + 1 }}</td>
                    <td>{{ coord.lat.toFixed(6) }}</td>
                    <td>{{ coord.lng.toFixed(6) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  }
</div>
